import React from "react"
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { getFieldByName, getFilterFieldValues, getOtherFieldOptions, getRootComponent, isInputElement } from "../../utilities/ElementUtils";
import { DialogBase, Props } from "./DialogBase";

interface State {
  pickedFieldOptions;
}

export class DialogForSearchSingleItemFromApiComponent extends DialogBase<Props,State>  {
	constructor(props: Props) {
			super(props);
	}

	componentDidMount(): void {
		if (this.props.ele.FilterField) {
				const filterField = getFieldByName(this.props.ele.FilterField, this.props.ele);
				const filterValues = getFilterFieldValues(filterField);
				this.setState({ pickedFieldOptions: filterValues });
		}
	}
	
	getSummaryListColumnOptions = () => {
		const options = [{
				label: this.props.isEng ? 'No summary list filter' : 'Pas de filtre summary list',
				value: null
		}];

		const root = getRootComponent(this.props.ele);
		const sections = root?.ListOfFormSections ?? [];

		sections.forEach((section: FormSections) => {
			section?.ListOfFormSubSections?.forEach((subSection: FormSubSections) => {
					subSection?.ListOfFormSectionElements?.forEach((element: FormSectionElements) => {
							if (element?.Datatype === "SummaryList" && element.subSectionList?.length) {
									const summaryTitle = this.props.isEng ? element.ENUTitle : element.FRATitle;
									const summaryId = element.Id;
									const columns = element.subSectionList[0]?.ListOfFormSectionElements ?? [];
									columns.forEach((column: FormSectionElements) => {
											const columnKey = column?.LoadBindName;
											if (!columnKey) return;
											const columnTitle = this.props.isEng ? column.ENUTitle : column.FRATitle;
											options.push({
													label: `${summaryTitle || summaryId || 'Summary List'} - ${columnTitle || columnKey}`,
													value: `${summaryId}|${columnKey}`
											});
									});
							}
					});
			});
		});

		const unique = new Map<string, { label: string; value: string | null }>();
		options.forEach(option => {
				const key = option.value === null ? 'null' : String(option.value);
				if (!unique.has(key)) {
						unique.set(key, option);
				}
		});

		return Array.from(unique.values());
	}
    
	onChangeHandler = (newValue) => {
		this.props.ele.FilterField = newValue;
		let totalOption = [];
		let eleListPrior = [];

		if (this.props.ele.parent.parent.Datatype==='Row') {
			let currentSection = this.props.ele.parent.parent.parent.parent as FormSections;
			let currentSubSeq = this.props.ele.parent.parent.parent.Sequence;
			currentSection.ListOfFormSubSections.filter(sub=>sub.Sequence<=currentSubSeq).forEach((sub) => {
					sub.ListOfFormSectionElements.forEach(ele=>{
							if (ele.Datatype==='Row'&&ele.subSectionList) {
									ele.subSectionList[0].ListOfFormSectionElements.forEach(el=>{
											if (sub.Sequence<this.props.ele.parent.parent.parent.Sequence || ele.Sequence==this.props.ele.parent.parent.Sequence&&el.Sequence<this.props.ele.Sequence || ele.Sequence<this.props.ele.parent.parent.Sequence){
													eleListPrior.push(el)
											}
									})
							} else if (sub.Sequence<this.props.ele.parent.parent.parent.Sequence || ele.Sequence<this.props.ele.parent.parent.Sequence){
											eleListPrior.push(ele)
							}
					})
			})
		} else {
			let currentSection = this.props.ele.parent.parent as FormSections;
			let currentSubSeq = this.props.ele.parent.Sequence;
			currentSection.ListOfFormSubSections.filter(sub=>sub.Sequence<=currentSubSeq).forEach((sub) => {
					sub.ListOfFormSectionElements.forEach(ele => {
							if (ele.Datatype==='Row'&&ele.subSectionList) {
									ele.subSectionList[0].ListOfFormSectionElements.forEach(el => {
											if (sub.Sequence<this.props.ele.parent.Sequence || ele.Sequence<this.props.ele.Sequence) {
													eleListPrior.push(el)
											}
									})
							} else {
									if (sub.Sequence<this.props.ele.parent.Sequence || ele.Sequence<this.props.ele.Sequence) {
											eleListPrior.push(ele)
									}
							}
					})
			})
		}

		let pickedFieldOptions = eleListPrior.filter(ele => ele.LoadBindName?.replace(/\s/g, "") == newValue)
			.map(q => {
					const container = {};
					if (q.Datatype == "Checkbox") {
							const yLOVValue = new LOVValues();
							yLOVValue.code = "Y";
							yLOVValue.description = "Y";
							const nLOVValue = new LOVValues();
							nLOVValue.code = "N";
							nLOVValue.description = "N";
							container[q.LoadBindName] = [yLOVValue, nLOVValue];
					} else {
							container[q.LoadBindName] = q.ListOfLOVValues;
					}
					return container;
			});
		totalOption.push(...pickedFieldOptions);
		
		this.setState({ pickedFieldOptions: totalOption });
		this.props.callback();
	}

	generateHtmlString = () => {
		let html = [];
		html.push(
			<>
				<Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle}
						footer={this.renderFooter()}
						visible={this.props.dialogVisible} style={{ width: '50vw' }}
						onHide={() => this.props.callback(false)}>
							{this.defaultComponentFields()}
				</Dialog>
			</>
		);
		return html;
	}

	defaultComponentFields = () => {
			let htmlString = [];
			const summaryElement = this.props.ele as any;
			const summaryFilterSelection = summaryElement?.filterSummaryListId && summaryElement?.filterSummaryListColumn
					? `${summaryElement.filterSummaryListId}|${summaryElement.filterSummaryListColumn}`
					: null;

			htmlString.push(
				<div>
					{this.scriptHtml()}
					<div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>
							<label htmlFor={"tbl_" + this.props.ele.PostScript + this.props.ele.Id}>Post Script</label>
						</div>
						<div style={{ width: '60%' }}>   
							<InputTextarea 
								id={"postScript_${this.props.ele.Sequence}"}
								className="ontario-input"
								value={this.props.ele.PostScript} 
								onChange={(e) => { this.props.ele.PostScript = e.target.value; this.props.callback() }} />
						</div>
					</div>

					{this.regexHtml()}

					{this.updateBindingFieldHtml()}

					{this.listValuesApiHtml()}

					{this.questionHintHtml()}

					{this.emptyErrorMessageHtml()}

					{this.errorMessageHtml()}
					
					{this.richTextErrorMessageHtml()}

					{this.tooTipHtml()}

					{this.hintExpansionTitleHtml()}

					{this.calloutBoxHtml()}
					
					<div style={{ display:  "flex",  marginTop: '10px' }}>
						<div style={{ width: '25%' }}>Filtering Field</div>
						<div style={{ width: '60%' }}>
								<Dropdown options={getOtherFieldOptions(this.props.ele)} style={{width:'100%'}}
										className="ontario-dropdown-small"
										optionLabel="description"
										optionValue="code"
										value={this.props.ele.FilterField}
										onChange={(e) => {
												this.onChangeHandler(e.value);}
										}
								/>
						</div>
					</div>
					<div style={{ display:  "flex" , marginTop: '10px' }}>
						<div style={{ width: '25%' }}>Filtering Value</div>
						<div style={{ width: '60%', marginTop: '5px' }}>
							<div>
								<Dropdown style={{width:'100%'}}
										className="ontario-dropdown-small"
										options={this.state?.pickedFieldOptions?.[0] ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
										value={this.props.ele.FilterValue}
										optionLabel="description"
										optionValue="code"
										placeholder="Filtering value"
										onChange={(e) => {
												this.props.isEng ? (this.props.ele.FilterValue = e.value) : (this.props.ele.FilterValueFRA = e.value);
												this.props.callback();
										}}
									/>
							</div>
						</div>
					</div>
					{this.props.ele.Datatype === "SearchAutocomplete" && (
						<div style={{ display: "flex", marginTop: '10px' }}>
							<div style={{ width: '25%' }}>
								<label htmlFor={`summary_list_filter_${this.props.ele.Sequence}`}>Summary list filter</label>
							</div>
							<div style={{ width: '60%' }}>
								<Dropdown
									id={`summary_list_filter_${this.props.ele.Sequence}`}
									className="ontario-dropdown-small"
									optionLabel="label"
									optionValue="value"
									options={this.getSummaryListColumnOptions()}
									value={summaryFilterSelection}
									placeholder="Select summary list column"
									style={{ width: '100%' }}
									showClear
									onChange={(e) => {
										const elementAny = this.props.ele as any;
										if (!e.value) {
											elementAny.filterSummaryListId = null;
											elementAny.filterSummaryListColumn = null;
										} else {
											const [summaryId, columnName] = (e.value as string).split('|');
											elementAny.filterSummaryListId = summaryId;
											elementAny.filterSummaryListColumn = columnName;
										}
										this.props.callback();
									}}/>
								</div>
						</div>
					)}

					{this.indentHtml()}
					{this.maskSummaryHtml()}

					{this.fieldOnTopHtml()}

					<div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>
							<label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Show Optional/Required Label:</label>
						</div>
						<div style={{ width: '60%' }}>
							<Checkbox value={this.props.ele.showOptionalLabel ?? true} 
								id={"show_optional_label_" + this.props.ele.Sequence}
								onChange={(e) => { 
										this.props.ele.showOptionalLabel = e.checked; 
										this.props.callback() 
								}} 
								checked={this.props.ele.showOptionalLabel ?? true}/>
						</div>
					</div>

					{isInputElement(this.props.ele) && (
						<div style={{ display: "flex", marginTop: '10px' }}>
								<div style={{ width: '25%' }}>
										<label htmlFor={"collect_submit" + this.props.ele.Sequence}>Collect for submit:</label>
								</div>
								<div style={{ width: '60%' }}>
										<Checkbox value={this.props.ele.input?.submitCollect} 
											id={"collect_submit" + this.props.ele.Sequence}
											onChange={(e) => { 
													this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: e.checked}; 
													this.props.callback() 
											}} 
											checked={this.props.ele.input?.submitCollect}/>
								</div>
						</div>
					)}

					{this.excludeFromPayload()}
					{this.InitialVisibility()}

					<div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>
							<label htmlFor={"allow_multi_sel_" + this.props.ele.Sequence}>Allow multiple selections:</label>
						</div>
						<div style={{ width: '60%' }}>
							<Checkbox value={this.props.ele.MultipleSelectionsProps?.allowMultipleSelection ?? false} 
								id={"allow_multi_sel_" + this.props.ele.Sequence}
								onChange={(e) => { 
									if (this.props.ele.MultipleSelectionsProps) {
										this.props.ele.MultipleSelectionsProps.allowMultipleSelection = e.checked;
									} else {
										this.props.ele.MultipleSelectionsProps = {allowMultipleSelection: e.checked};
									}

									this.props.callback();
								}} 
								checked={this.props.ele.MultipleSelectionsProps?.allowMultipleSelection ?? false}/>
						</div>
					</div>
					{this.props.ele.MultipleSelectionsProps?.allowMultipleSelection && <div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>
							<label htmlFor={"allow_multi_sel_" + this.props.ele.Sequence}>Display list size:</label>
						</div>
						<div style={{ width: '60%' }}>
							<InputText
									className="ontario-input"
									id={`disp_list_size_${this.props.ele.Sequence}`}
									placeholder={"5"}
									value={this.props.ele.MultipleSelectionsProps?.displayListSize ?? '5'}
									onChange={(e) => {
											this.props.ele.MultipleSelectionsProps.displayListSize = e.target.value;
											this.props.callback();
							}}/>
						</div>
					</div>}
					{this.props.ele.MultipleSelectionsProps?.allowMultipleSelection && <div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>
							<label htmlFor={"allow_multi_sel_" + this.props.ele.Sequence}>Max number of selections:</label>
						</div>
						<div style={{ width: '60%' }}>
							<InputText
									className="ontario-input"
									id={`max_no_sel_${this.props.ele.Sequence}`}
									placeholder={'2'}
									value={this.props.ele.MultipleSelectionsProps?.maxNumberOfSelection ?? '2'}
									onChange={(e) => {
											this.props.ele.MultipleSelectionsProps.maxNumberOfSelection = e.target.value;
											this.props.callback();
							}}/>
						</div>
					</div>}

					{this.apiConfigsHtml()}
				</div>
			)

			return htmlString;
    }

    renderFooter = () => {
			return (
				<div>
					<Button label="OK" icon="pi pi-check" onClick={() => {
						this.props.callback(false);
					}} />
					<Button label="Cancel" onClick={() => { this.props.callback(false) }} />
				</div>
			);
    }

    render() {
			return (
				this.generateHtmlString()
			)
    }
}
